import { Component } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';

@Component({
  selector: 'app-tyc',
  templateUrl: './tyc.component.html',
  styles: [
    '.tyc { background-color: #ffffff; padding: 20px 40px; border-radius: 20px; }',
    '.closeIconWrapper { position: fixed; right: 10px; top: 10px; background-color: #00b4d5; width: 35px; height: 35px; display: flex; justify-content: center; align-items: center; border-radius: 50%; z-index: 1000000000000000; cursor: pointer; }',
    '.closeIconWrapper:hover { filter: brightness(1.06); }',
    '.closeIconWrapper:active { filter: brightness(0.9); }',
    '.closeIconWrapper img { width: 90%; height: 90%; object-fit: cover; }'
  ]
})
export class TycComponent {

  constructor(
    private _dialog: DialogService
  ) { }

  close() {
    this._dialog.closeDialog()
  }

}
